import React, { Fragment } from "react";
import Header2 from "../../components/header/Header2";
import { Link } from "react-router-dom";
import Scrollbar from "../../components/WhatsAppBtn/WhatsAppBtn";
import CtaSection from "../../components/CtaSection/CtaSection";
import Footer from "../../components/footer/Footer";
import Bg from "../../images/bg/page_bg01.jpg";
import icon from "../../images/icon/eye-icon.svg";
import caseImg from "../../images/testimonial/sa-tes04.jpg";
import cIcon1 from "../../images/icon/csd-icon01.svg";
import cIcon2 from "../../images/icon/csd-icon02.svg";
import cIcon3 from "../../images/icon/csd-icon03.svg";
import cIcon4 from "../../images/icon/csd-icon04.svg";
import cIcon from "../../images/icon/check-icon.svg";
import caseStudies from "../../api/case";

const CaseStudyVDIWindows11 = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header2 />
        <section
          className="page-title pt-200 pos-rel bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap">
              <div className="row mt-none-30 align-items-end">
                <div className="col-lg-9 mt-30">
                  <div className="page-title-box">
                    <span className="sub-title">
                      <img src={icon} alt="" /> Caso de Sucesso
                    </span>
                    <h2 className="title">
                      VDI Windows 11 para Escritório de Advocacia <br />{" "}
                      suportando 300 usuários simultâneos <br /> com economia de
                      40% em hardware
                    </h2>
                  </div>
                </div>
                <div className="col-lg-3 mt-30">
                  <div className="count-box">
                    <h2 className="number">
                      300<span className="suffix">+</span>
                    </h2>
                    <span className="text">
                      usuários simultâneos <br /> suportados
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="csd-img pt-70 pb-65">
          <div className="container">
            <div className="item-details_image pos-rel">
              <img
                src={caseImg}
                alt="VDI Windows 11 - Escritório de Advocacia"
              />
            </div>
          </div>
        </div>
        <div className="sd-ser-content_wrap pb-90">
          <div className="container">
            <div className="sd-ser-content">
              <h2 className="sd-title">
                O desafio: mobilidade e segurança para ambiente jurídico
              </h2>
              <p className="sd-content">
                Um dos maiores escritórios de advocacia do país enfrentava
                desafios críticos de mobilidade e segurança. Com mais de 300
                advogados, 450 colaboradores e 15 escritórios regionais, a
                empresa precisava garantir acesso seguro aos sistemas jurídicos
                de qualquer localização, mantendo compliance com LGPD e sigilo
                advocatício. O modelo tradicional de workstations locais
                limitava a produtividade e gerava custos elevados com manutenção
                e atualizações.
              </p>
              <br />
              <p className="sd-content">
                A situação se agravou durante a pandemia, quando o trabalho
                remoto se tornou obrigatório. Os advogados não conseguiam
                acessar sistemas críticos como PJe, PROJUDI e base de
                jurisprudência de forma segura. Isso resultou em perda de prazos
                processuais, multas aplicadas pela OAB e risco de vazamento de
                informações confidenciais. A necessidade de uma solução que
                oferecesse mobilidade total, segurança máxima e compliance
                regulatório tornou-se urgente.
              </p>
            </div>
          </div>
        </div>
        <div className="csd-ser_warp">
          <div className="container">
            <div className="csd-ser_inner ul_li_between">
              <div className="csd-item ul_li">
                <div className="xb-icon">
                  <img src={cIcon1} alt="" />
                </div>
                <h6 className="xb-text">
                  cliente : <span> Escritório de Advocacia Nacional</span>
                </h6>
              </div>
              <div className="csd-item ul_li">
                <div className="xb-icon">
                  <img src={cIcon2} alt="" />
                </div>
                <h6 className="xb-text">
                  serviços : <span> VDI Windows 11 + Segurança</span>
                </h6>
              </div>
              <div className="csd-item ul_li">
                <div className="xb-icon">
                  <img src={cIcon3} alt="" />
                </div>
                <h6 className="xb-text">
                  conclusão : <span> 60 dias</span>
                </h6>
              </div>
              <div className="csd-item ul_li">
                <div className="xb-icon">
                  <img src={cIcon4} alt="" />
                </div>
                <h6 className="xb-text">
                  localização : <span> Nacional, Brasil</span>
                </h6>
              </div>
            </div>
          </div>
        </div>
        <div className="sd-service_wrap pt-90 pb-130">
          <div className="container">
            <div className="sd-ser-outcome">
              <div className="sd-heading">
                <h2 className="sd-title">Requisitos do projeto</h2>
                <p className="sd-content">
                  O cliente necessitava de uma solução VDI que oferecesse acesso
                  seguro de qualquer localização, compliance com LGPD e sigilo
                  advocatício, integração com sistemas jurídicos (PJe, PROJUDI),
                  suporte a certificado digital A3, além de alta performance
                  para aplicações gráficas intensivas.
                </p>
              </div>
              <div className="sd-list-item ul_li">
                <ul className="sd-ser-list list-unstyled">
                  <li>
                    <img src={cIcon} alt="" />
                    Análise de perfis de usuário (advogados, assistentes,
                    suporte)
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Implementação de VDI Windows 11 otimizado
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Configuração de políticas de segurança LGPD
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Integração com Active Directory jurídico
                  </li>
                </ul>
                <ul className="sd-ser-list list-unstyled">
                  <li>
                    <img src={cIcon} alt="" />
                    Suporte a certificado digital A3 via USB
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Otimização para sistemas PJe e PROJUDI
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Implementação de DLP (Data Loss Prevention)
                  </li>
                  <li>
                    <img src={cIcon} alt="" />
                    Auditoria e relatórios de conformidade
                  </li>
                </ul>
              </div>
            </div>
            <div className="sd-heading csd-heading pt-90">
              <h2 className="sd-title">Solução implementada & resultados</h2>
              <p className="sd-content">
                <span>Solução:</span> Implementamos uma solução VDI Windows 11
                completa com perfis otimizados para diferentes tipos de
                usuários. A arquitetura incluiu integração com certificado
                digital A3, políticas rigorosas de DLP, backup automático de
                sessões e auditoria completa de acesso. Configuramos otimizações
                específicas para sistemas jurídicos, incluindo PJe, PROJUDI e
                ferramentas de jurisprudência, garantindo performance superior
                mesmo em conexões remotas.
              </p>
              <br />
              <p className="sd-content">
                <span>Resultados:</span> O escritório conseguiu suportar 300
                usuários simultâneos com performance superior, alcançou 95% de
                redução em chamados de suporte técnico e 40% de economia com
                hardware local. Durante a implementação, não houve perda de
                prazos processuais e o escritório manteve 100% de compliance com
                LGPD e sigilo advocatício. A produtividade aumentou 60% com
                advogados podendo trabalhar de qualquer localização com acesso
                completo aos sistemas. A solução permitiu que o escritório
                expandisse para 8 novas filiais sem investimento adicional em
                infraestrutura local.
              </p>
            </div>

            <div className="similar-casestudy pt-80">
              <h2 className="similar-casestudy-title">Casos similares</h2>
              <div className="row mt-none-30">
                {caseStudies.slice(1, 4).map((cases, citem) => (
                  <div className="col-lg-4 col-md-6 mt-30" key={citem}>
                    <div className="casestudy-item">
                      <div className="casestudy-img">
                        <Link
                          onClick={ClickHandler}
                          to={`/casestudy-details/${cases.slug}`}
                        >
                          <img src={cases.img} alt="" />
                        </Link>
                        <div className="content_wrap">
                          <h3 className="item_title">{cases.title}</h3>
                          <span className="item_tag">{cases.slug}</span>
                        </div>
                      </div>
                      <Link
                        onClick={ClickHandler}
                        to={`/casestudy-details/${cases.slug}`}
                        className="xb-overlay"
                      ></Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <CtaSection />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default CaseStudyVDIWindows11;
